import React from "react";
import { useLocation } from "react-router-dom";
import LogoDakikaNos from "../icons/Arrows/LogoDakikaNos";
import VendorSidebar from "./VendorSidebar";
import "./vendorFlow.css";
import LanguagePicker from "../translations/LanguagePicker";

function VendorLayout({ activeKey, children }) {
  const location = useLocation();
  const isPreview = location.pathname.includes("-preview");
  const hideNavbarLogo = activeKey === "account-settings";

  return (
    <div
      className={`vendor-flow-layout${
        hideNavbarLogo ? " vendor-flow-layout-hide-navbar-logo" : ""
      }`}
    >
      <header className="vendor-flow-navbar">
        {hideNavbarLogo ? null : (
          <div className="vendor-flow-navbar-logo">
            <LogoDakikaNos />
          </div>
        )}
        <LanguagePicker />
      </header>

      <div className="vendor-flow-body">
        <VendorSidebar activeKey={activeKey} isPreview={isPreview} />
        <main className="vendor-flow-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default VendorLayout;
